import { Home, MessageCircle, Search } from "lucide-react";
import { MESSAGES, waLink } from "@/data/content";
import { FadeUp } from "./Reveal";

const PANELS = [
  {
    icon: Home,
    eyebrow: "FOR OWNERS",
    title: "هل لديك عقار ترغب في تسويقه أو تأجيره؟",
    text: "اعرض عقارك مع شيادن ودع فريقنا يتولى الوصول إلى العملاء الجادين باحترافية ووضوح.",
    cta: "اعرض عقارك مع شيادن",
    msg: MESSAGES.owner,
    bg: "bg-navy",
    testId: "owner",
  },
  {
    icon: Search,
    eyebrow: "FOR SEEKERS",
    title: "لم تجد ما تبحث عنه؟",
    text: "أخبرنا بمواصفات العقار الذي تبحث عنه — المدينة، الحي، النوع والميزانية — وسيساعدك فريق شيادن في الوصول إلى الخيارات المناسبة.",
    cta: "أرسل طلبك عبر واتساب",
    msg: MESSAGES.seeker,
    bg: "bg-petrol",
    testId: "seeker",
  },
];

export default function CtaSplit() {
  return (
    <section data-testid="cta-split-section" className="grid md:grid-cols-2">
      {PANELS.map((p, i) => (
        <div
          key={p.testId}
          data-testid={`cta-panel-${p.testId}`}
          className={`${p.bg} relative overflow-hidden px-6 py-20 md:px-14 md:py-28`}
        >
          <span
            className="pointer-events-none absolute -bottom-8 -end-4 font-display text-[10rem] leading-none text-white/5"
            aria-hidden="true"
          >
            {p.testId === "seeker" ? "؟" : "ش"}
          </span>
          <FadeUp>
            <p.icon className="h-10 w-10 text-copper" strokeWidth={1.25} />
            <span className="mt-6 block font-display text-xs tracking-[0.35em] text-copper">
              {p.eyebrow}
            </span>
            <h3 className="mt-4 max-w-md font-head text-3xl md:text-4xl font-extrabold leading-snug text-cream">
              {p.title}
            </h3>
            <p className="mt-5 max-w-md text-sm md:text-base leading-relaxed text-cream/65">
              {p.text}
            </p>
            <a
              href={waLink(p.msg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`cta-${p.testId}-whatsapp-button`}
              className="group mt-9 inline-flex items-center gap-3 rounded-full bg-copper px-7 py-4 font-head text-sm md:text-base font-bold text-navy transition-transform duration-300 hover:scale-[1.04]"
            >
              <MessageCircle className="h-5 w-5 transition-transform duration-300 group-hover:-rotate-12" />
              {p.cta}
            </a>
          </FadeUp>
        </div>
      ))}
    </section>
  );
}
